import React, { Component } from 'react';

import { Header, Navbar, NavPills } from '@C';
import { RouteSetup } from '@C/Admin/Users';
import ErrorBoundary from '@C/Error';
import { authService } from '@S';

const routes = [
  {
    name: 'Users List',
    path: '/admin/users/list',
  },
  {
    name: 'User Bunk',
    path: '/admin/users/bunk/:id',
  },
];

class UsersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const role = authService.currentUserRole;
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Referral program" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <div className="page-title">
                <h1> All Users </h1>
              </div>
              <ErrorBoundary>
                <NavPills routes={routes} />
              </ErrorBoundary>
              <ErrorBoundary>
                {role === 'Site Admin' && <RouteSetup />}
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { UsersPage };
